(function () {
  'use strict';

  function mostRecentItemsDataService($http) {
      var baseUrl = '[BuildifyApiHost]/api/mostrecentitems';

      function getMostRecentItems() {
          return $http.get(baseUrl).then(
              function (response) {
                  return response.data;
              });
      }

      return {
        getMostRecentItems: getMostRecentItems
      }
  }

  mostRecentItemsDataService.$inject = ['$http'];

  angular.module('ecap.dashboards').service('mostRecentItemsDataService', mostRecentItemsDataService);
})();
